import { BillingApi } from "@/types";
import { SentryErrorEmitterService } from "@/services";


export type CalculatedPrice = {
    state: string,
    price: number,
    currency: string,
} | { state: 'unknown'}

export class PriceHelperNew {

    public static calculatePrice = (
        priceObject: BillingApi.ArticlePurchasePrice,
        isCommercialCustomer: boolean,
        showPromotionPrice: boolean,
    ): CalculatedPrice => {

        if ([undefined, null].indexOf(priceObject) >= 0) {
            SentryErrorEmitterService.sendSentryReport(
                'priceObject is null or undefined',
                { error: 'priceObject is null or undefined' },
                { service: 'new price helper'}
            );
            return { state: 'unknown' };
        }

        if (priceObject.netAmount === -1) {
            return { state: 'unknown' };
        }

        let netAmount = priceObject.netAmount;
        let grossAmount = priceObject.grossAmount;
        if ([undefined, null].indexOf(priceObject.promotionalNetAmount) < 0
            && [undefined, null].indexOf(priceObject.promotionalGrossAmount) < 0
            && showPromotionPrice)
        {
            netAmount = priceObject.promotionalNetAmount;
            grossAmount = priceObject.promotionalGrossAmount;
        }

        const result = { state: 'loaded', currency: priceObject.currency }
        if (isCommercialCustomer) {
            return { ...result, price: netAmount };
        } else {
            return { ...result, price: grossAmount };
        }
    }


}
